// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._154iidpf{top:0}\n._1kemd8h4{image-rendering:pixelated}\n._1ltvidpf{left:0}\n._80om1kdv{cursor:text}\n._bfhku67f{background-color:#fff}\n._kqswh2mm{position:relative}\n._kqswstnw{position:absolute}\n._lswu1j28{fill:transparent}\n._o572qvpr{white-space:pre}\n._uizt1kdv{-webkit-user-select:text;-ms-user-select:text;user-select:text}\n._uiztglyw{-webkit-user-select:none;-ms-user-select:none;user-select:none}", ""]);
// Exports
module.exports = exports;
